module.exports = __webpack_public_path__ + "img/11_95.b2dd47ee.png";